import styled from "styled-components";
export const TicketsMenuStyle = styled.div``;
